import React from 'react'
import './styles.scss'

function PageContainer({ children }) {
  return <div className="page-container">{children}</div>
}

export default PageContainer
